import SquareCard from 'components/organisms/SquareCard';
import IconButton from '../../../atoms/button/IconButton';
import useOnclickOutside from 'react-cool-onclickoutside';
import { useEffect, useState } from 'react';
import LegalDocumentApi from '../../../../api/legalDocumentApi';
import ReactMarkdown from 'react-markdown';
import { useIsCurrentUserModerator } from '../../../../utils/hooks';
import TextArea from '../../../atoms/text-area/TextArea';
import Button from '../../../atoms/button';
import LegalDocumentData from '../../../../types/legalDocumentData';

export interface CookieModalProps {
  onClose?: () => void;
  onAcceptAll?: () => void;
  onAcceptRequired?: () => void;
  onAcceptSelected?: () => void;
}

export default function CookieModal({ onClose }: CookieModalProps) {
  const [cookieDocument, setCookieDocument] = useState<LegalDocumentData>();
  const [editText, setEditText] = useState('');
  const [editMode, setEditMode] = useState(false);
  const isModerator = useIsCurrentUserModerator();

  const ref = useOnclickOutside(
    () => {
      onClose?.();
    },
    { eventTypes: ['mouseup'] }
  );

  useEffect(() => {
    async function fetchData() {
      const fetchedCookieDocument = await LegalDocumentApi.getLegalDocument('cookies');
      setCookieDocument(fetchedCookieDocument);
      setEditText(fetchedCookieDocument.text);
    }

    fetchData();
  }, []);

  async function handleSave() {
    if (!cookieDocument) return;
    await LegalDocumentApi.updateLegalDocument('cookies', { ...cookieDocument, text: editText });
    setEditMode(false);
    setCookieDocument({ ...cookieDocument, text: editText });
  }

  return (
    <SquareCard
      className="self-stretch relative max-w-screen-lg animate-slidein overflow-y-scroll p-16 mx-6 sm:mx-16 my-12"
      innerRef={ref}
    >
      <div className="modal-card">
        <IconButton
          className="absolute right-8 top-8"
          iconSize="lg"
          visualType="no-bg"
          onClick={onClose}
          icon="close"
        />
        {!editMode && cookieDocument && <ReactMarkdown className="markdown-text">{cookieDocument?.text}</ReactMarkdown>}
        {editMode && (
          <div>
            <TextArea className="w-full h-[500px] mb-8" state={[editText, setEditText]} />
            <div className="flex justify-between">
              <Button onClick={handleSave}>Save</Button>
              <Button visualType="secondary" onClick={() => setEditMode(false)}>
                Cancel
              </Button>
            </div>
          </div>
        )}
        {isModerator && !editMode && (
          <IconButton className="absolute right-8 bottom-8" onClick={() => setEditMode(true)} icon="edit" />
        )}
      </div>
    </SquareCard>
  );
}
